const APIErrorCodes = {
  EXCEEDED_MAX_RETRIES: 'SG-3000',
  FETCH_ERROR: 'SG-3100',
};

Object.freeze(APIErrorCodes);

export default APIErrorCodes;
